import * as React from "react";
import { useEffect } from "react";
import System from "src/helper/system";
import { useBOMStore } from "src/hooks/bom";
import BomListingHeader from "./BomListing/BomListingHeader/BomListingHeader";
import BomTabsListing from "./BomListing/BomTabsListing";
import Common from "./Common";
import { useSearchParams } from "react-router-dom";
import SystemAlerts from "../../component/SystemAlerts";
import useReduxState from "../../hooks/useReduxState";
import $ from "jquery";
import { isObject } from "underscore";
import { useSelector } from "react-redux";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useBOMProjectStore } from "src/hooks/bom_project";
import { useProductPricingStore } from "src/hooks/productPricing";
import { useProductInventoryStore } from "src/hooks/productInventory";

const isReRunPartMatch = System.getParams().isReRunPartMatch
  ? System.getParams().isReRunPartMatch
  : true;

export function BomTabsList() {
  const [searchParams] = useSearchParams();
  /**
   * Owner : Trilok
   * Date  : 08/02/2023
   * Note  : Added true to restrict to re-initialize top var.
   */
  const [top] = useReduxState({}, "BOM_DETAIL_TOP_PARAM_FOP_LIMIT", true);
  const [
    { bom_detail_by_bom_id, bomSortByUpdatedDate },
    {
      get_bom_detail_by_bom_id,
      get_bom_detail_by_bom_id_with_type,
    },
  ] = useBOMStore();
  const [BomTabList__Component__Loader] = useReduxState(
    searchParams.get(Common.param_key_BomTabList)
      ? searchParams.get(Common.param_key_BomTabList)
      : Common.default_component_BomTabList.param_value,
    Common.redux_key_BomTabList,
    "BomTabList__Component__Loader"
  );
  const bom_id = System.getParams().bomId;

  useEffect(() => {
    async function fetchHere() {
      if (bom_id !== undefined && bom_id !== "") {
        let c = System.getParams();
        delete c.go;
        history.pushState(null, null, "?" + $.param(c));
        let res = await get_bom_detail_by_bom_id({ bomId: bom_id });
        if (!res.payload) {
          window.history.back();
        }
        if(!res?.payload?.isColumnMatch) {
          System.alert(
              'Define the column headers to match your data. Part Number is required.',
              'danger'
            );
        }
      } else {
        window.history.back();
      }
    }

    fetchHere();
  }, []);

  useEffect(() => {
    if (bom_detail_by_bom_id !== undefined && bom_detail_by_bom_id === null) {
      window.history.back();
    }
  }, [bom_detail_by_bom_id]);

  useEffect(() => {
    async function f() {
      let top_here = 10;
      if (
        top[
          Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type
        ] !== undefined &&
        top[
          Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type
        ].top
      ) {
        top_here =
          top[
            Common.chain_BomTabList[BomTabList__Component__Loader]
              .api_fetch_type
          ].top;
      }
      top_here = top_here === 10 ? 20 : top_here;
      let param = {
        bomId: bom_id,
        isReRunPartMatch,
        matchType:
          Common.chain_BomTabList[BomTabList__Component__Loader].api_fetch_type,
        top: top_here,
      };

      if (bomSortByUpdatedDate) {
        param.sortColumn = "updated_date";
        param.sortOrder = "desc";
      }
      let res = await get_bom_detail_by_bom_id_with_type(param);
      if (localStorage.getItem("uploaded_file")) {
        localStorage.removeItem("uploaded_file");
        let nothing_found_for_Exact_tab = false;
        try {
          if (res.payload.data.Exact.count < 1) {
            nothing_found_for_Exact_tab = true;
          }
        } catch (e) {}

        if (
          localStorage.getItem("flash_message_rematch") &&
          nothing_found_for_Exact_tab === false
        ) {
          localStorage.removeItem("flash_message_rematch");
        }
      }
    }

    if (top && isObject(top) && Object.keys(top).length > 0) {
      /**
       * Author: Trilok
       * Date: 2/3/2023
       * Reason: stop initial call
       */
      const {
        Exact: { top: exactTop },
        Multiple: { top: multipleTop },
        NoMatch: { top: nomatchTop },
      } = top;
      if (exactTop !== 20 || multipleTop !== 20 || nomatchTop !== 20) {
        f();
      }
    }
  }, [top]);
  /**
   * Owner : Ramya
   * Date  : 31/07/2024
   * Note  : BomFileUpload, RenameBOM, BOMOpened, Quickly Add a part - Adobe script.
   *
   */

  const [{ inventoryList }, { get_inventory_by_id }, {}] = useProductInventoryStore();
  const [{ pricingList }, {}, {}] = useProductPricingStore();

  const getInventory = (ERPPartNumber) => {
    return get_inventory_by_id(ERPPartNumber)
  };
  const getPricing = (
    ERPMFRPartNumber,
    ERPPartNumber,
    ERPPartNumberModified
  ) => {
    ERPPartNumber = ERPPartNumberModified ? "" : ERPPartNumber;
    if (pricingList[ERPMFRPartNumber + "-" + ERPPartNumber]) {
      return pricingList[ERPMFRPartNumber + "-" + ERPPartNumber];
    }
    return [];
  };


  const BomDetails = useSelector(
    (state) => state.entities.model_BOM.bomDetailByBomID
  );
  const bomDetailsTable = useSelector(
    (state) => state.entities.model_BOM.bomDetailByBomIDWithType
  );
  const [{ bom_project_list }, {}, {}] = useBOMProjectStore();
  if (
    BomDetails?.bomId &&
    Object.keys(bomDetailsTable).length) {
    let storageEvent ;
    if(localStorage.getItem("adobeEventType") ) {
      storageEvent = localStorage.getItem("adobeEventType") ;
    }
    else if( localStorage.getItem("adobeEventBOMType")) {
      storageEvent = localStorage.getItem("adobeEventBOMType");
    }
    if (storageEvent) {
      let bomDetails = { ...BomDetails };
      if (bom_project_list) {
        bomDetails.projectName =
          bom_project_list[bom_detail_by_bom_id.projectId]?.projectName;
      }
      if (storageEvent === "bomOpened") {
        let prodDetails = [];
        if (bomDetailsTable?.Exact?.records) {
          Object.entries(bomDetailsTable?.Exact?.records).map((data, i) => {
            prodDetails.push(data[1].product);
          });
        }
        prodDetails.map((data, ind) => {
          let copyObj = { ...data };
          copyObj.qas = Object.keys(inventoryList).length && getInventory(data?.ERPPartNumber)?.qas;
          let priceVal = System.checkPriceValues(pricingList) && getPricing(
            data.ERPMFRPartNumber || data.erpMfrPartNumber,
            data.ERPPartNumber,
            data.ERPPartNumberModified
          );
          copyObj.priceSource = priceVal && priceVal[0]?.priceSource || '';
          copyObj.subtotal = priceVal && priceVal[0]?.marketPrice * 1000 || 0;
          prodDetails[ind] = copyObj;
        });

        if (
          Object.keys(bomDetails).length &&
          Object.keys(bomDetailsTable).length &&
          prodDetails?.length
        ) {
          HelperAdobeEvent.trackingAdobeEvent({
            bomDetails,
            bomDetailsTable,
            prodDetails,
          });
        }
      } else if (storageEvent === "bomQuicklyAddPart") {
        let prodDetails = localStorage.getItem("prodPayload") ;
        prodDetails = JSON.parse(prodDetails);
        prodDetails.qas = Object.keys(inventoryList).length && getInventory(prodDetails?.ERPPartNumber)?.qas;
        let priceVal = System.checkPriceValues(pricingList) && getPricing(
          prodDetails.ERPMFRPartNumber || prodDetails.erpMfrPartNumber,
          prodDetails.ERPPartNumber,
          prodDetails.ERPPartNumberModified
        );
        prodDetails.priceSource = priceVal && priceVal[0]?.priceSource || '';
        prodDetails.subtotal = priceVal && priceVal[0]?.marketPrice * 1000 || 0;
        prodDetails.priceSource = priceVal && priceVal[0]?.priceSource || '';
        prodDetails.subtotal = priceVal && priceVal[0]?.marketPrice * 1000 || 0;
        if (
          Object.keys(bomDetails).length &&
          Object.keys(bomDetailsTable).length &&
          Object.keys(prodDetails)?.length
        ) {
          HelperAdobeEvent.trackingAdobeEvent({
            bomDetails,
            bomDetailsTable,
            prodDetails,
          });
        }
      } else {
        if (
          Object.keys(bomDetails).length &&
          Object.keys(bomDetailsTable).length
        ) {
          HelperAdobeEvent.trackingAdobeEvent({
            bomDetails,
            bomDetailsTable,
          });
        }
      }
    }
  }

  return (
    <>
      <div className="logged-screen">
        <div className="">
          <div id="main" className="">
            {/* BOM-file-listing page */}
            <div className="bom-copy">
              <BomListingHeader /> 
              <SystemAlerts />
              <BomTabsListing />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
